import { ValidateEmail } from "./ValidateEmail";

export default ValidateEmail;
